export default __webpack_public_path__ + "static/media/cancel.676f3651.svg";